import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: 'name',
                label: '规则名称',
                type: 'input'
            },
            {
                prop: 'enable',
                label: '是否启用',
                type: 'select',
                selectval: comMapping.$flag
            },
            {
                prop: 'executeAction',
                label: '执行动作',
                type: 'input'
            },
            {
                prop: 'bsExplain',
                label: '说明',
                type: 'input'
            }
        ],
        searchdata: {
            name: '',
            enable: '',
            executeAction: '',
            bsExplain: ''
        },
        headData: [
            {
                title: '业务专项',
                prop: 'bsType',
                width: 110,
                custom: true

            },
            {
                title: '规则名称',
                prop: 'name',
                width: 130,
                custom: true

            },
            {
                title: '是否启用',
                prop: 'enable',
                width: 40,
                custom: true

            },
            {
                title: '优先级',
                prop: 'level',
                width: 40,
                custom: true

            },
            {
                title: '说明',
                prop: 'bsExplain',
                width: 160,
                custom: true

            },
            {
                title: '操作',
                prop: 'cz',
                custom: true,
                fixed: 'right',
                width: 250
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
